import { createMultipleParam } from '@appscience/utils'
import { indexBy, prop } from 'ramda'
import { API_URL } from 'src/config/environment'
import { ToHubPackage } from '../../views/warehouse/to-warehouse/hub/model'
import apiCreator from '../api-creator'
import { Api_PackageAndShipment } from '../common/shipment-model'
import { handleErrorWithDefaultValue } from '../common/utils'
import { parseDate } from '@app/utils/date'

interface Params {
  warehouseIds: Array<string>
}

export function getToHubPackages({
  warehouseIds,
}: Params): Promise<Record<string, ToHubPackage>> {
  return apiCreator
    .get(
      `${API_URL.TWIN}/packages?${createMultipleParam(
        warehouseIds,
        'to_warehouse_id',
      )}&shipment_status=shipped`,
    )
    .then(res => {
      const rawData: Array<Api_PackageAndShipment> = res.data.packages
      return indexBy(prop('id'), rawData.map(remapToHubPackage))
    })
    .catch(handleErrorWithDefaultValue({}))
}

export function remapToHubPackage({
  package: packageData,
  shipment,
}: Api_PackageAndShipment): ToHubPackage {
  return {
    id: packageData.id,
    invoiceNumber: packageData.package_invoice,
    currencyId: packageData.currency,
    sumCost: packageData.package_sum,
    toWarehouseId: shipment.to_warehouse_id,
    itemsQuantity: packageData.items_quantity,
    departureDate: parseDate(shipment.departure_date),
    plannedDeliveryDate: parseDate(shipment.planned_departure_date),
    transporterId: shipment.transporter,
    prevWarehouseId: shipment.from_warehouse_id,
    temperatures: packageData.temperature,
    trackIds: shipment.track_number,
    isHazmat: packageData.hazmat,
    tag: shipment.tag,
    express: shipment.express,
    packageComment: packageData.provider_comments,
  }
}
